import { render, staticRenderFns } from "./chairman.vue?vue&type=template&id=74b1980f&scoped=true"
import script from "./chairman.vue?vue&type=script&lang=js"
export * from "./chairman.vue?vue&type=script&lang=js"
import style0 from "./chairman.vue?vue&type=style&index=0&id=74b1980f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b1980f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sseinfo\\src_finreport_xc\\tdinfo-szs-finreport-pc-\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b1980f')) {
      api.createRecord('74b1980f', component.options)
    } else {
      api.reload('74b1980f', component.options)
    }
    module.hot.accept("./chairman.vue?vue&type=template&id=74b1980f&scoped=true", function () {
      api.rerender('74b1980f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chairman.vue"
export default component.exports